import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Global } from 'src/app/_services/global.service';
import { StreamService } from 'src/app/_services/streamer.service';
import { forkJoin } from 'rxjs';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';
import { StageService } from 'src/app/_services/stage.service';
import { ActivatedRoute } from '@angular/router';
import { StreamingItemComponent } from './streaming-item/streaming-item.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { InfiniteGridComponent } from 'src/app/ui-library/component/infinite-grid/infinite-grid.component';
import { ModalService } from 'src/app/_services/modal.service';
import { SearchFormComponent } from 'src/app/ui-library/search-form/search-form.component';
import { SearchField } from 'src/app/_models/body';
import { SearchFieldType } from 'src/app/common/constants';

@Component({
  selector: 'app-streaming',
  templateUrl: './streaming.component.html',
  styleUrls: ['./streaming.component.css']
})
export class StreamingComponent extends InfiniteGridComponent {
  @ViewChild('SearchForm', { static: false }) SearchForm: SearchFormComponent

  streamerSource: Array<any>
  assetSource: Array<any>
  stageSource: Array<any>
  streamerId: string
  searchSection: Array<SearchField> = [
    { name: 'ID', key: 'Id' },
    { name: 'Theme Contains', key: 'Theme_Contains' },
    { name: 'Description Contains', key: 'Description_Contains' },
    { name: 'Status', key: 'Status', type: SearchFieldType.Selector, options: ['Enable', 'Disable'] },
  ]
  constructor(
    private streamService: StreamService,
    public global: Global,
    private datePipe: DatePipe,
    private assetService: MmitaAssetService,
    private stageService: StageService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private nzModalService: NzModalService,
    private modalService: ModalService
  ) {
    super(global)
    this.streamerId = this.route.snapshot.paramMap.get('streamerId');
  }


  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'ID', field: 'id', sortable: false },
      { headerName: 'Theme', field: 'theme', sortable: false },
      { headerName: 'Description', field: 'description', sortable: false },
      { headerName: 'Streamer', field: 'streamer.fullName', sortable: false },
      { headerName: 'Event Status', field: 'status', sortable: false },
      { headerName: 'Record Status', field: 'channel.recordStatus', sortable: false },
      { headerName: 'Channel Status', field: 'channel.status', sortable: false },
      {
        headerName: 'Created At', field: 'createdAt', valueFormatter: (params) => {
          return this.datePipe.transform(params.value, 'short')
        }
      },
      {
        headerName: 'Started At', field: 'startedAt', valueFormatter: (params) => {
          return this.datePipe.transform(params.value, 'short')
        }
      },
      {
        headerName: 'Channel Started At', field: 'channel.startedAt', valueFormatter: (params) => {
          return this.datePipe.transform(params.value, 'short')
        }
      },
      {
        headerName: 'Channel Finished At', field: 'channel.finishedAt', valueFormatter: (params) => {
          return this.datePipe.transform(params.value, 'short')
        }
      },
      {
        headerName: 'Action',
        pinned: 'right',
        minWidth: 180,
        cellRenderer: params => {
          return `
                      <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
                      ${this.setDefaultStreamingIcon(params?.data)}
                      <i class="fas fa-fw fa-copy text-success" id="copy" style="margin-right:3px; cursor: pointer;"></i>
                      <i class="fas fa-fw fa-edit text-primary" id="edit" style="margin-right:3px; cursor: pointer;"></i>
                      <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="delete" style="margin-right:3px; cursor: pointer;"></i>`;
        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'moreDetail':
              this.modalService.showDetail(params.data, 'Streaming Event Detail')
              break;
            case 'edit':
              this.editItem(params?.data?.id)
              break;
            case 'delete':
              this.modalService.createNzDeleteModal(() => this.delete.call(this, params?.data?.id))
              break;
            case 'copy':
              const data = this.createCopyEventDto(params.data)
              this.streamService.createStreamingEvent(data).subscribe(res => {
                this.loadData()
                this.toastr.success('copy successfully')
              })
              break
            case 'defaultStreamEvent':
              this.setDefaultStreamEvent(params?.data?.id, params?.data?.description, params?.data?.isDefaultEvent)
              break
          }
        },
      },
    ];
  }

  private setDefaultStreamingIcon(data) {
    return `<i class="fas fa-fw fa-house-user ${data?.isDefaultEvent ? ' text-success' : 'text-secondary'}" id="defaultStreamEvent" style="margin-right:3px; cursor: pointer;"  title="Set to Home Page"></i>`
  }


  loadData() {
    this.gridApi.deselectAll();
    this.gridApi.purgeInfiniteCache();
  }

  ngOnInit() {
    this.setColumnDefs();
  }


  ngAfterViewInit() {
    this.setDatasource((prop) => this.streamService.getStreamingEvents(this.streamerId ? { StreamerId: this.streamerId, ...prop } : prop))
    this.getSource()
  }

  getSource() {

    forkJoin({
      streamerSource: this.streamService.getAll(),
      assetSource: this.assetService.getAll({ BusinessType: 'Streamer', PageSize: -1 }),
      stageSource: this.stageService.getStagesForKeyInfo({
        StageType: 'Streamer',
        PageSize: '-1'
      })
    }).subscribe(res => {
      this.streamerSource = res.streamerSource.data.map(item => {
        return { ...item, name: `Name:${item.fullName}, ID:${item.id}` }
      })
      this.assetSource = res.assetSource.data
      this.stageSource = res.stageSource.data.map(item => {
        return { ...item, name: `ID:${item.id}, Description:${item?.assetDescription}` }
      })
    })
  }

  editItem(id) {
    // 需求：存在多页面操作item的可能性，需要实时更新item最新内容
    this.streamService.getStreamingEvents({ Id: id }).subscribe(res => {
      const orgData = res.data[0]
      this.showItem(orgData)
    })
  }

  showItem(orgData?: any) {
    const modal = this.nzModalService.create({
      nzContent: StreamingItemComponent,
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto',
      },
      nzFooter: null,
      nzTitle: orgData ? 'Edit Streaming Event' : 'Create Streaming Event',
      nzComponentParams: {
        orgData: orgData, // 传递初始数据
        assetOptions: this.assetSource,
        streamerOptions: this.streamerSource,
        stageOptions: this.stageSource,
      },
      nzWidth: 800
    });

    // Handle modal result
    modal.afterClose.subscribe(result => {
      if (result || modal.componentInstance.updatedFlag) {
        this.toastr.success(`Saved Successfully...!`, 'Success');
        this.loadData()
      }
    });
  }

  setDefaultStreamEvent(id, description, isDefaultEvent) {
    this.streamService.setDefaultStreamEvent(id).subscribe((res) => {
      this.loadData()
      if (isDefaultEvent) {
        this.toastr.success(`Cancel ${description} as default stream event`)
      } else {
        this.toastr.success(`Set ${description} as default stream event`)
      }
    })
  }

  delete(id) {
    this.streamService.deleteEvent(id)
      .subscribe(data => {
        this.loadData();
        this.toastr.success('Data Deleted Successfully...!', 'Success');
      });
  }

  createCopyEventDto(ev) {
    return {
      type: ev?.type,
      description: ev.description,
      streamerId: ev.streamer.id,
      assetId: ev.asset.id,
      theme: ev.theme,
      stageIds: ev.stages.map(item => item.id),
      coverUrl: ev?.cover?.url,
      startedAt: ev.startedAt,
      channel: ev.channel,
    }
  }
}